//
// Generated class BankOpening
//

/// <reference path="BankOpening_ManagedObject.ts" />

class BankOpening extends BankOpening_ManagedObject
{

}
